export default {
  common: {
    language: "Sprache",
  },
};
